module.exports = __webpack_public_path__ + "static/media/outdoor_marina_permacool.6bf17028.jpg";